import React, { FunctionComponent } from 'react'

import { Trans, useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import {
  useGetSurveyWindowQuery,
  useOpenSurveyWindowMutation,
} from 'store/surveyWindow/surveyWindowApi'

import { SurveyWindow } from 'store/surveyWindow/types'

import { PromptCard } from './PromptCard'

interface SurveyWindowDraftProps {
  currentSurveyWindow: SurveyWindow
}

export const SurveyWindowDraft: FunctionComponent<SurveyWindowDraftProps> = ({
  currentSurveyWindow,
}) => {
  const { t } = useTranslation()
  const { isFetching: isFetchingCurrent } = useGetSurveyWindowQuery()

  const [openSurveyWindow, { isLoading: isLoadingOpen, isError: isErrorOpen }] =
    useOpenSurveyWindowMutation()

  const onClick = () => {
    openSurveyWindow({ id: currentSurveyWindow.id })
  }

  return (
    <PromptCard
      title="surveys.draft.title"
      description="surveys.draft.description"
      onClick={onClick}
      buttonText="surveys.draft.button"
      isLoading={isFetchingCurrent || isLoadingOpen}
      error={isErrorOpen}
      guidance={
        <Trans
          i18nKey="surveys.draft.guidance"
          components={[
            <Link to="/employees" />,
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={t('surveys.draft.guidanceLinkAnnounce')}
            >
              |
            </a>,
          ]}
        />
      }
    />
  )
}
